// src/utils/apiClient.js
const ApiClient = {
  async sendGetRequest(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Request failed with code: ${response.status}`);
      }
      return await response.json(); // or response.text() if it's plain text
    } catch (error) {
      throw error;
    }
  },

  async sendPostRequest(url, payload) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error(`Request failed with code: ${response.status}`);
      }
      return await response.json(); // or response.text()
    } catch (error) {
      throw error;
    }
  },
};

export default ApiClient;
